import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type ChartVariantType } from '@blaze-shared/elements-domain';
import { isNullish } from '@blaze-shared/shared-util';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

/**
 * Except a single value chart. It has the same migration in 002-single-chart.migration.ts
 */
export const chartV2Migration: PropsMigration = {
  mode: 'props',
  description:
    'Fix chart title and description properties and migrate bold font style to font weight',
  run: (props: PartialPropsOf<ChartVariantType>): void => {
    const { content } = props;
    const titleUpdates: Record<string, any> = {};
    const titleBlockUpdates: Record<string, any> = {};

    if (!isNullish(content?.chart?.title)) {
      titleUpdates.label = content.chart.title;
      delete content.chart.title;
    }

    if (!isNullish(content?.chart?.description)) {
      titleUpdates.description = content.chart.description;
      delete content.chart.description;
    }

    /**
     * Migrate bold style to font weight property
     */
    if (content?.font?.style?.includes('bold')) {
      titleBlockUpdates.fontWeight = '700';
      content.font.style = content.font.style.filter((style) => style !== 'bold');
    }

    if ([titleUpdates, titleBlockUpdates].some((updates) => Object.keys(updates).length)) {
      props.content = {
        ...props.content,
        title: {
          ...props.content?.title,
          ...titleUpdates,
        },
      };
      props.style = {
        ...props.style,
        titleBlock: {
          ...props.style?.titleBlock,
          ...titleBlockUpdates,
        },
      };
    }
  },
};
